export default "__VITE_ASSET__DspfEjFB__"